import Fuzzbug from "../Fuzzbug.js";
import AScene from "../../library/ExtendedObjects/AScene.js";
import NavBar from "../game/NavBar.js";
import gameData from "../../gameData.js";
import Popup from "../game/Popup.js";

export default class Customize extends AScene {
  static get KEY() { return 'Customize'; }

  create() {
    gameData.currentScene = "Customize";
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.customizerComplete = true;
    gameData.totalOutlines = 0;

    this.customizerInd = 0;
    this.isNext = false;
    this.patternReady = false;
    this.isHiding = false;
    this.selectedColor = null;

    this.maskData = [];

    this.fuzzbug = new Fuzzbug(this, this.mid.x, -50, 1, "Idle").setDepth(1);

    gameData.fuzzColor = "f2eddf";
    gameData.fuzzColorName = "White";

    this.fuzzbug.paintFuzzbug();

    //this.playJingle();

    this.createCustomizer();
  }

  playJingle() {
    let counter = 0;
    //console.log(this.sound.sounds);
    for (let i = 0; i < this.sound.sounds.length; i++) {
      //console.log(this.sound.sounds[i].currentMarker.name);
      if (this.sound.sounds[i].currentMarker && this.sound.sounds[i].currentMarker.name === "jingle_patterns") counter++;
    }
    if (counter === 0) gameData.jingle = this.playSound("jingle_patterns", .2, true);
  }

  createCustomizer() {
    this.bg = this.addImage(this.mid.x, this.mid.y, "Bckg");

    if (this.shelf) this.shelf.destroy();
    this.shelf = this.addImage(-300, this.mid.y * 2, "UI_Customize").setOrigin(.5, 1);

    if (this.navBar) this.navBar.destroy();
    this.navBar = new NavBar(this);
    this.addToParent(this.navBar);

    this.doneBtn = this.addButton(830, 300, "Btn_Done", {}, () => {
      this.playSound("click");
      this.endCustomizer();
    });
    this.doneBtn.setEnabled(false);
    this.doneBtn.setScale(0);

    this.nextBtn = this.addButton(830, 300, "Btn_Next", {}, () => {
      this.playSound("click");
      this.initPatterns();
    });
    this.nextBtn.setEnabled(false);
    this.nextBtn.setScale(0);

    this.prevBtn = this.addButton(170, 300, "Btn_Prev", {}, () => {
      this.playSound("click");
      this.initColors();
    });
    this.prevBtn.setEnabled(false);
    this.prevBtn.setScale(0);

    this.maskButtons = [];
    this.colorButtons = [];
    this.curMaskButton = null;

    let stencils = ["Dots", "Stripes", "Waves", "Stars", "Circles"];
    for (let i = 0; i < 5; i++) {
      let stencil = "Stencil" + (i + 1);
      this.addMaskButton(290 + i * 111, stencils[i], stencil);
    }

    for (let x = 0; x < gameData.fuzzColors.length; x++) {
      this.addColorButton(62 + x * 100, 700, x, gameData.fuzzColors[x].color);
    }

    this.cSelector = this.addImage(this.colorButtons[1].x, this.colorButtons[1].y, "Selected_Ring");
    this.mSelector = this.addImage(this.maskButtons[0].x, this.maskButtons[0].y, "Selected_Ring");
    this.cSelector.setAlpha(0);
    this.mSelector.setAlpha(0);

    this.tweenInCustomizer();
  }

  tweenInCustomizer() {
    this.playSound("platform_tween");

    this.addTween(this.shelf, 1000, { x: this.mid.x }, Phaser.Math.Easing.Quadratic.Out);
    this.addTween(this.cSelector, 500, { alpha: 1, delay: 300 }, Phaser.Math.Easing.None);

    let d = 0;
    this.colorButtons.forEach((btn) => {
      this.addTween(btn, 500, { scaleX: 1, scaleY: 1, delay: 100 + (d * 100) }, Phaser.Math.Easing.Back.Out);
      d++;
    });

    let m = 0;
    this.maskButtons.forEach((btn) => {
      this.addTween(btn, 500, { scaleX: 1, scaleY: 1, delay: 300 + (m * 100) }, Phaser.Math.Easing.Back.Out);
      m++;
    });

    if (!this.isNext) {
      this.isNext = true;
      this.selectedColor = this.colorButtons[1];

      this.addTween(this.nextBtn, 500, { scaleX: 1, scaleY: 1, delay: 600 }, Phaser.Math.Easing.Back.Out,
        () => { this.nextBtn.setEnabled(true); });
    }
  }

  pauseGame() {
    gameData.gamePaused = true;

    this.playSound("click");

    this.navBar.home.setEnabled(false);
    this.doneBtn.setEnabled(false);
    this.nextBtn.setEnabled(false);
    this.prevBtn.setEnabled(false);

    this.maskButtons.forEach((btn) => { btn.setEnabled(false); });
    this.colorButtons.forEach((btn) => { btn.setEnabled(false); });

    this.popup = new Popup(this);
  }

  resumeGame() {
    gameData.gamePaused = false;

    this.navBar.home.setEnabled(true);

    if (this.customizerInd === 0) {
      this.doneBtn.setEnabled(false);
      this.nextBtn.setEnabled(true);
      this.prevBtn.setEnabled(false);

      this.maskButtons.forEach((btn) => { btn.setEnabled(false); });
      this.colorButtons.forEach((btn) => { btn.setEnabled(true); });
    }
    else if (this.customizerInd === 1) {
      if (this.doneBtn.scaleX > 0) this.doneBtn.setEnabled(true);
      this.nextBtn.setEnabled(false);
      this.prevBtn.setEnabled(true);

      this.maskButtons.forEach((btn) => { btn.setEnabled(true); });
      this.colorButtons.forEach((btn) => {
        if (btn.alpha === 1) {
          btn.setEnabled(true);
        } else {
          btn.setEnabled(false);
        }
      });
    }

    this.popup.destroy();
  }

  addMaskButton(x, buttonKey, stencilKey) {
    let maskButton = this.addButton(x, 600, "Btn_" + buttonKey, {}, () => {
      //console.log("clicked");
      this.playSound("click");
      this.killTween(this.mSelector);

      this.fuzzbug.stencil = "";
      this.fuzzbug.stencilName = "";
      this.fuzzbug.paintFuzzbug();

      this.fuzzbug.stencil = stencilKey;
      this.curMaskButton = maskButton;

      if (stencilKey === "Stencil1") this.fuzzbug.stencilName = "Dots";
      else if (stencilKey === "Stencil2") this.fuzzbug.stencilName = "Stripes";
      else if (stencilKey === "Stencil3") this.fuzzbug.stencilName = "Waves";
      else if (stencilKey === "Stencil4") this.fuzzbug.stencilName = "Stars";
      else if (stencilKey === "Stencil5") this.fuzzbug.stencilName = "Circles";

      this.mSelector.x = x;
      this.mSelector.setAlpha(0);
      this.mSelector.setScale(1.5);
      this.cSelector.setAlpha(0);

      if (!this.patternReady) {
        this.patternReady = true;

        this.colorButtons.forEach((btn) => {
          if (btn.color === this.fuzzbug.color) {
            btn.setAlpha(.25);
            btn.setEnabled(false);
          } else {
            btn.setAlpha(1);
            btn.setEnabled(true);
          }
        });
      }

      this.addTween(this.mSelector, 500, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Bounce.Out);
    });

    maskButton.setScale(0);
    maskButton.setAlpha(0);
    maskButton.setEnabled(false);

    maskButton.hasStencil = stencilKey ? true : false;
    maskButton.stencilKey = stencilKey;

    this.maskButtons.push(maskButton);
  }

  addColorButton(x, y, colorInd, color) {
    let clr = gameData.fuzzColors[colorInd].name;
    let colorButton = this.addButton(x, y, "Btn_" + clr, {}, () => {
      this.playSound("click");

      this.killTween(this.cSelector);

      this.paintBug(color, clr);

      this.cSelector.x = x;
      this.cSelector.setAlpha(0);
      this.cSelector.setScale(1.5);

      if (this.customizerInd === 0) this.selectedColor = this.colorButtons[colorInd];

      if (!this.isNext) {
        this.isNext = true;

        this.addTween(this.nextBtn, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
          () => { this.nextBtn.setEnabled(true); });
      }

      this.addTween(this.cSelector, 500, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Bounce.Out);
    });

    colorButton.color = color;
    colorButton.setScale(0);

    this.colorButtons.push(colorButton);
  }

  paintBug(color, colorName) {
    // console.log(this.customizerInd);
    if (this.customizerInd === 0) {
      this.fuzzbug.color = color;
      this.fuzzbug.colorName = colorName;

      gameData.fuzzColor = color;
      gameData.fuzzColorName = colorName;
    }
    else {
      this.fuzzbug.stencilColor = color;

      gameData.fuzzStencilColor = color;
      gameData.fuzzStencilName = this.fuzzbug.stencilName;
    }

    this.fuzzbug.paintFuzzbug();

    this.checkPattern();
  }

  initPatterns() {
    this.customizerInd = 1;

    this.maskButtons.forEach((btn) => {
      btn.setAlpha(1);
      btn.setEnabled(true);
    });

    if (this.fuzzbug.stencilColor !== "") {
      this.mSelector.setAlpha(1);

      this.colorButtons.forEach((btn) => {
        if (btn.color === this.fuzzbug.color) {
          btn.setAlpha(.25);
          btn.setEnabled(false);

          if (this.cSelector.x === btn.x) {
            this.cSelector.setAlpha(0);
            this.isHiding = true;
          }
        } else {
          btn.setAlpha(1);
          btn.setEnabled(true);
        }

        if (btn.color === this.fuzzbug.stencilColor) this.cSelector.x = btn.x;
      });
    } else {
      this.cSelector.setAlpha(0);

      this.colorButtons.forEach((btn) => {
        btn.setAlpha(.25);
        btn.setEnabled(false);
      });

      this.doneBtn.setEnabled(false);
      this.addTween(this.doneBtn, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.Out);
    }

    this.nextBtn.setEnabled(false);

    this.addTween(this.nextBtn, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.Out);

    this.checkPattern();

    this.addTween(this.prevBtn, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
      () => {
        this.prevBtn.setEnabled(true);
      });
  }

  initColors() {
    this.customizerInd = 0;
    this.patternReady = false;
    this.isNext = false;

    if (this.fuzzbug.stencilColor !== "") {
      this.mSelector.setAlpha(.25);
    }
    else {
      this.mSelector.setAlpha(0);
      if (this.fuzzbug.stencil) this.fuzzbug.stencil = "";
    }

    this.maskButtons.forEach((btn) => {
      btn.setAlpha(.25);
      btn.setEnabled(false);
    });

    this.colorButtons.forEach((btn) => {
      btn.setAlpha(1);
      btn.setEnabled(true);
    });

    this.cSelector.x = this.selectedColor.x;
    this.cSelector.setAlpha(1);

    this.prevBtn.setEnabled(false);
    this.doneBtn.setEnabled(false);
    this.addTween(this.prevBtn, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.doneBtn, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.Out);

    this.addTween(this.nextBtn, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
      () => {
        this.nextBtn.setEnabled(true);
      });
  }

  checkPattern() {
    // console.log(this.fuzzbug.color, this.fuzzbug.stencil, this.fuzzbug.stencilColor, this.isHiding);

    if (this.fuzzbug.stencil !== "" && this.fuzzbug.stencilColor !== "" && this.fuzzbug.color !== this.fuzzbug.stencilColor) {
      this.unHideDone();
    } else {
      this.hideDone();
    }
  }

  unHideDone() {
    this.addTween(this.doneBtn, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
      () => {
        this.isHiding = false;
        this.doneBtn.setEnabled(true);
      });
  }

  hideDone() {
    this.doneBtn.setEnabled(false);
    this.addTween(this.doneBtn, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In,
      () => {
        this.doneBtn.setScale(0, 0);
        this.isHiding = true;
      });
  }

  endCustomizer() {
    gameData.fuzzColor = this.fuzzbug.color;
    gameData.fuzzStencil = this.fuzzbug.stencil;
    gameData.fuzzStencilColor = this.fuzzbug.stencilColor;
    gameData.customFuzzbug = true;
    gameData.fuzzIndex = 0;

    this.tweenOutCustomizer();
  }

  tweenOutCustomizer() {
    this.fuzzbug.leaveGame();
    this.navBar.tweenOutNav();

    this.cSelector.setAlpha(0);
    this.mSelector.setAlpha(0);

    this.playSound("platform_tween");

    this.doneBtn.setEnabled(false);
    this.addTween(this.prevBtn, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.doneBtn, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.shelf, 500, { x: -550, delay: 600 }, Phaser.Math.Easing.Quadratic.In);

    for (let m = 0; m < this.maskButtons.length; m++) {
      //console.log(this.maskButtons[m]);
      this.maskButtons[m].setEnabled(false);
      this.addTween(this.maskButtons[m], 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    }

    for (let c = 0; c < this.colorButtons.length; c++) {
      //console.log(this.colorButtons[c]);
      this.colorButtons[c].setEnabled(false);
      this.addTween(this.colorButtons[c], 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    }
  }

  cleanUp(scene) {
    //console.log(gameData.level);
    this.fuzzbug.cleanUp();

    this.doneBtn.destroy();
    this.shelf.destroy();
    this.cSelector.destroy();
    this.mSelector.destroy();
    this.bg.destroy();

    for (let i = 0; i < this.maskButtons.length; i++) {
      this.maskButtons[i].destroy();
    }

    for (let i = 0; i < this.colorButtons.length; i++) {
      this.colorButtons[i].destroy();
    }

    if (scene) this.scene.start(scene);
  }
}